let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("4HXk3")), load("9UOtD")]).then(() => parcelRequire('j5C3s'));